import { render, staticRenderFns } from "./BlogPostBreadcrumb.vue?vue&type=template&id=79d17dc4"
import script from "./BlogPostBreadcrumb.vue?vue&type=script&lang=js"
export * from "./BlogPostBreadcrumb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports